import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import URL from '../../../constants/url';
import style from './ContactlessDetail.module.css';
import { getFormatKRW, getFormatLocalTime } from '../../../assets/js/comm';
import ToastPopup from '../../../components/comm/ToastPopup';
import axiosApi from '../../../api/daonAxios';
import CODE from '../../../constants/code';


const ContactlessDetail = () => {

    /**************
     * 선언부
     ***************/

    const user = JSON.parse(sessionStorage.getItem("loginUser"));

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    //console.log(" ==========> ContactlessDetail :: ", userTimeZone );
    const navigate = useNavigate();

    const location = useLocation();
    const { state } = location;
    //console.log( " ==========> ContactlessMain >> ContactlessDetail state :  ", state );
    // 진료상세 state
    const [ telemedicineDetail, setTelemedicineDetail ] = useState( {} );

    const [ attachCnt, setAttachCnt ] = useState( 0 );

    const resizeRef = useRef();

    const [comment, setComment] = useState('');

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    // 화면초기화렌더제어 useRef 선언
    const isInitialRender = useRef(true);

    /**************
     * 기능부 구현
     ***************/

    const autoResizeTextarea = (resizeRef) => {
        resizeRef.current.style.height = "5rem";
        let height = resizeRef.current.scrollHeight;
        resizeRef.current.style.height = `${height}px`;
    };

    const handleTextareaChange = (e) => {
        const value = e.target.value;
        setComment(value);
        autoResizeTextarea(resizeRef);
    };

    const handleOnCopyUrl = (url) => {
        navigator.clipboard.writeText(url)
            .then(() => {
                    setToastMessage("URL copying was successful.")
                    setToast(true);
                }
            )
            .catch(err => {
                console.log(" =========> handleOnCopyUrl : ", err);
                setToastMessage("Failed to copy URL.");
                setToast(true);
            });
    };

    /* 위-경도 사용시..
    const getLocation = () => {
        if (!navigator.geolocation) {
            setLocateError('Geolocation is not supported by this browser.');
            return;
        }
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setLocatePos({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            },
            (err) => {
                setLocateError(err.message);
            }
        );
    };
    useEffect( () => {

        // getLocation();

    }, []);
    */

    /**
     * 해외비대면진료 상세 조회 API 호출
     *
     */
    const searchTelemedicineDetail = () => {

        const requestOverseasUrl = "/overseas/retrieveTelemedicineDetail";


        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const requestBody = {
            telmdcApplId: state?.telmdcApplId,
            telmdcSchdulId: state?.telmdcSchdulId,
        }

        axiosApi.post(requestOverseasUrl, requestBody, requestOption)
            .then((res) => {
                const resultData = res.data;
                if(resultData.resultCode === CODE.RCV_SUCCESS) {
                    const teleDetail = resultData.result?.telemedicineDetail;
                    setTelemedicineDetail(teleDetail);
                    setAttachCnt(resultData?.result?.patntAtchCnt);
                    if(teleDetail?.telmdcMemoCn !== undefined ) {
                        setComment(teleDetail?.telmdcMemoCn);
                    }
                } else {
                    setTelemedicineDetail({});
                    setAttachCnt(0);
                }
            })
            .catch((err) => {
               console.log( "=========> searchTelemedicineDetail err : ", err);
            });
    };

    const saveTelemedicinePatient = () => {

        const requestOverseasSaveUrl = "/overseas/saveTelemedicinePatient";

        const jToken = localStorage.getItem("jToken");


        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        const requestBody = {
            telmdcApplId: state?.telmdcApplId,
            telmdcMemoCn: comment,
            usrInfoId: user?.usrInfoId,
        };

        axiosApi.post(requestOverseasSaveUrl, requestBody, requestOption)
            .then((res) => {
                const resultData = res.data
                if(resultData.resultCode === CODE.RCV_SUCCESS) {
                    setToastMessage("The comment was saved successfully.");
                    setToast(true);
                } else {
                    setToastMessage("Failed to save the comment.");
                    setToast(true);
                }
            })
            .catch((err) => {
                console.log( "=========> saveTelemedicinePatient err : ", err);
                setToastMessage("Failed to save the comment. (Error)");
                setToast(true);
            })
    };


    /**
     * 비대면상담진료실 입장
     * @param joinUrl
     */
    const handleOnJoinMeeting = (joinUrl) => {
        // React Native 에서 처리
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: joinUrl
            }));
        } else {
            // 일반 웹 브라우저
            window.open(joinUrl, '_blank', 'noopener,noreferrer');
        }
    };

    /**
     * 결제 진행
     */
    const handleOnPayment = () => {

        navigate(URL.PAYMENT_REGISTER, { state: {
            telmdcApplId: telemedicineDetail?.telmdcApplId
                , hsptlCd: telemedicineDetail?.cnncHsptlCd
                , deptCd: telemedicineDetail?.cnncDeptCd
                , patntNo: telemedicineDetail?.rsvctmPatntNo
                , amount: telemedicineDetail?.reqAmount
                , telmdcSchdulId: telemedicineDetail?.telmdcSchdulId
        }});
    };

    // 뒤로가기
    const handleOnBack = () => {
        navigate(URL.CONTACTLESS_MAIN, { replace: true });
    };

    // 초기화
    useEffect(() => {

        if(isInitialRender.current) {
            searchTelemedicineDetail();
            isInitialRender.current = false;
        }
    });

    return (
        <>

            <HeadSub onBack={handleOnBack} title="Medical Details" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style['inform-box']}>
                        <strong>Consultation Schedule</strong>
                            <div className={style['inner-box']}>
                                <ul>
                                    <li>
                                        <p>Local Time</p>
                                            <span>{
                                                telemedicineDetail?.telmdcBgngDt &&
                                                getFormatLocalTime(telemedicineDetail?.telmdcBgngDt, userTimeZone)}</span>
                                    </li>
                                    <li>
                                        <p>Korean Time</p>
                                        <span>{telemedicineDetail?.telmdcEntryDt}</span>
                                    </li>
                                </ul>
                            </div>
                    </div>

                    <div className={style['inform-box']}>
                        <strong>Medical Information</strong>
                            <div className={style['inner-box']}>
                                <ul>
                                    <li>
                                        <p>Hospital</p>
                                        <span>{telemedicineDetail?.cnncHsptlNm}</span>
                                    </li>
                                    <li>
                                        <p>Department</p>
                                        <span>{telemedicineDetail?.cnncDeptNm}</span>
                                    </li>
                                    <li>
                                        <p>Doctor</p>
                                        <span>{telemedicineDetail?.prcsMdcstffNm}</span>
                                    </li>
                                </ul>
                            </div>
                    </div>

                    <div className={style['inform-box']}>
                        <div className={style['link-box']}>
                            <strong>Consultation Room Access</strong>
                            <button className={style['link-copy-btn']}
                                onClick={ ["1", "3"].includes(telemedicineDetail?.schdulPrcsCd) ?
                                    () => handleOnCopyUrl(telemedicineDetail?.telmdcUrl)
                                    : undefined}
                            >
                                <span>Copy Entry Link</span>
                            </button>
                        </div>

                            <div className={style['inner-box']}>
                                <div className={style['enter-txt-box']}
                                     onClick={ ["1", "3"].includes(telemedicineDetail?.schdulPrcsCd) ?
                                         () => handleOnJoinMeeting(telemedicineDetail?.telmdcUrl)
                                         : undefined
                                }
                                >
                                    <strong>Enter Consultation Room</strong>
                                    <strong>{
                                        telemedicineDetail?.telmdcBgngDt &&
                                        getFormatLocalTime(telemedicineDetail?.telmdcBgngDt, userTimeZone)}</strong>
                                </div>
                            </div>
                    </div>


                    <div className={style['inform-box']} data-type="b">
                        <strong>Consultation Fee Payment</strong>

                        <div className={style['inner-box']}>
                            <ul>
                                <li>
                                    <p>Total Amount</p> {/* 추후, 결제금액 기능으로 넣어야함 */}
                                    <span>{getFormatKRW(telemedicineDetail?.reqAmount, "WON")}</span>
                                </li>
                            </ul>
                        </div>
                        <div className={style['bottom']}>
                            <button className='btn' data-btn-size="lg" data-btn-type="fill-main" data-btn-width='full'
                                    onClick={ handleOnPayment }
                             disabled={ telemedicineDetail?.paymtInfoHistId === undefined ? true : ( telemedicineDetail?.paymtStatCd !== "21" ? false : true ) }
                            >
                                <span>{ telemedicineDetail?.paymtStatCd !== "21" ? "Payment" : "Payment completed" }</span>
                            </button>
                        </div>
                    </div>

                    <div className={style['inform-box']}>
                        <strong>Comment</strong>

                        <div className={style['textarea-box']}>
                            <textarea
                                ref={resizeRef}
                                onKeyDown={() => {
                                    autoResizeTextarea(resizeRef);
                                }}
                                onKeyUp={() => {
                                    autoResizeTextarea(resizeRef);
                                }}
                                value={comment}
                                onChange={handleTextareaChange}
                                className="detail"
                                name="detail"
                                placeholder="Please enter any other symptoms."
                            />
                        </div>

                        <div className={style['bottom']}>
                            <button className='btn' disabled={!comment.trim()} data-btn-size="lg" data-btn-type="fill-main" data-btn-width='full'
                              onClick={ () => { saveTelemedicinePatient() } }
                            >
                                <span>Save</span>
                            </button>
                        </div>
                    </div>


                    <div className={style['inform-box']} data-type="b">
                        <strong>Attached Documents</strong>

                        <div className={style['inner-box']}>
                            <ul>
                                <li onClick={()=> {navigate(URL.FILE_UPLOAD, { state: { telmdcApplId: state?.telmdcApplId, patntAtchFileStr: telemedicineDetail?.patntAtchFileStr } })}}>
                                    <p>Registered Attachments</p>
                                    <span>{ attachCnt } <i className={style['i-arrow']}></i></span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className={style['notice-box']}>
                      <strong>Notice</strong>
                        <ul>
                            <li>For schedule changes or cancellations, please contact the administrator via email.</li>
                            <li>Contact Email: careplus.help@dgtpharm.com</li>
                        </ul>
                    </div>

                    {toast && (
                        <ToastPopup
                            message={toastMessage}
                            setToast={setToast}
                            position="center"
                            opacity="90"
                        />
                    )}

                </div>
            </div>
        </>
    );
};

export default ContactlessDetail;
